import { render, staticRenderFns } from "./NotificationBubble.vue?vue&type=template&id=478bbd62&"
import script from "./NotificationBubble.vue?vue&type=script&lang=ts&"
export * from "./NotificationBubble.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports